import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Popper from "vue3-popper";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';


createApp(App).use(router).component("Popper",Popper).component("VueCropper", VueCropper).mixin({
    methods: {
        showLoading: function () {
            document.getElementsByClassName('loader-container')[0].style.display = 'flex';
        },
        hideLoading: function () {
            document.getElementsByClassName('loader-container')[0].style.display = 'none';
        }
    }}).mount('#app')
